<div *ngIf="sinistres">
    <div *ngIf="imageSinistre.length >0">
        <ng-image-slider 
            [images]="imageSinistre"
            [infinite]="false"
            [autoSlide]="1"
            [imageSize]="{width:'500px',height:'500px'}"
            slideImage="1"
            #nav>
        </ng-image-slider>
    </div>
   
    <mat-card>
        <mat-card-content>
            <div class="flex-container">
                <div class="flex-item-left br">
                    <p>
                        <span class="title">Sinistre Du {{ sinistres.created_at| date: "mediumDate"}} à {{ sinistres.heureSinistre}}</span> <br>
                        <span class="subtitle"></span>
                    </p>
                    <p>
                        <mat-icon color="primary">location_on</mat-icon> 
                        <span style="margin-left:5px"><b>Adresse Actuelle du véhicule:</b> {{sinistres.lieu_actuel_vehic}}</span>
                    </p>
                    <p>
                        <mat-icon color="primary">location_on</mat-icon> 
                        <span style="margin-left:5px"><b>Adresse de l'accident:</b> {{sinistres.lieu_sinistre}}</span>
                    </p>
                    <p>
                        <mat-icon color="primary">car</mat-icon> 
                        <span class="label-text"><b>Vehicule:</b></span>
                        <span class="text-value">{{sinistres.vehicle_model}}{{sinistres.vehicle_mark}}</span>
                    </p>
                   
                </div>
                <div class="flex-item-right">
                    <div class="flex-container location-dispo">
                        <div class="flex-item-left location-amount">
                            <mat-icon>payments</mat-icon><span class="title" style="margin:5px"> Du {{sinistres.date_depart_reservation | date: "mediumDate"}} <br> Au {{sinistres.date_fin_reservation | date: "mediumDate"}}</span><br>
                            <span class="subtitle">Reservation !!</span>                         
                        </div>
                        <div class="flex-item-right diponibility-car">
                            <p>
                                 <mat-icon color="primary" *ngIf="sinistres.status=='Enregistré'">check_circle</mat-icon>
                                 <mat-icon color="primary"  *ngIf="sinistres.status=='Annuler'">do_not_disturb_on</mat-icon>
                                 <button mat-button [matMenuTriggerFor]="menu">{{sinistres.status}} <mat-icon>expand_more</mat-icon> </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)="changeStatus(sinistres.id,'Enregistré')" disabled="true">Enregistré</button>
                                    <button mat-menu-item (click)="changeStatus(sinistres.id,'Annulé')" [disabled]="sinistres.status=='Cloturé' || sinistres.status=='Annulé'">Annuler</button>
                                </mat-menu>
                                 <br>
                                 <span class="subtitle">Statut du sinistre</span>
                            </p>
                        </div>
                    </div>
                    <div class="flex-container location-dispo">
                        <div class="flex-item-left">
                            <p>
                                <mat-icon style="color: #193157 !important;margin:5px">verified_user</mat-icon>
                                <span class="title">{{sinistres.name_loc}} {{sinistres.surname_loc}}</span><br>
                                <span class="subtitle">Locataire du vehicule</span>                        
                            </p>
                        </div>
                        <div class="flex-item-right">
                            <p>
                                <mat-icon style="color: #193157 !important;margin:5px">verified_user</mat-icon>
                                <span class="title">{{sinistres.surname_prop}} {{sinistres.name_prop}}</span><br>
                                <span class="subtitle">Propretaire du vehicule</span>                        
                            </p>
                        </div>                   
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-accordion >
        <mat-expansion-panel style="margin-top:10px">
            <mat-expansion-panel-header>
            <mat-panel-title>
               Information du Sinistre
            </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="flex-container" >
                <div class="flex-item-left br">
                    <mat-list role="list">
                        <mat-list-item role="listitem">
                            <span class="label-text"><b>Nature Du sinistre :</b></span>
                            <span class="text-value">{{sinistres.NatureSinistre}}</span> 
                            <mat-divider></mat-divider>
                        </mat-list-item>
                        
                      
                        <mat-list-item role="listitem">
                            <span class="label-text"><b>Propriétaire :</b></span>
                            <span class="text-value">{{sinistres.NomPorprio}}</span> 
                            
                            <mat-divider></mat-divider>
                        </mat-list-item>
                        <mat-list-item role="listitem">
                            <span class="label-text"><b>Adresse propriétaire :</b></span>
                            <span class="text-value">{{sinistres.AdresseProprio}}</span> 
                            <mat-divider></mat-divider>
                        </mat-list-item>
                    </mat-list>
                </div>
                <div class="flex-item-right">
                    <mat-list role="list">
                        <mat-list-item role="listitem">
                            <span class="label-text"><b>Nom du conducteur :</b></span>
                            <span class="text-value">{{sinistres.NomConducteur}}</span>  
                            <mat-divider></mat-divider>
                        </mat-list-item>
    
                        <mat-list-item role="listitem">
                            <span class="label-text"><b>Assurance :</b></span>
                            <span class="text-value">{{sinistres.Assurance}}</span>                         
                            <mat-divider></mat-divider>
                        </mat-list-item>
                    
                        <mat-list-item role="listitem">
                            <span class="label-text"><b>N.Police d'assurance :</b></span>
                            <span class="text-value">{{sinistres.NumPoliceAssurance}}</span>
                            <mat-divider></mat-divider>
                        </mat-list-item>
                        
    
                    </mat-list>
                </div>
            </div>
        </mat-expansion-panel>
        <mat-expansion-panel style="margin-top:10px">
            <mat-expansion-panel-header>
                <mat-panel-title>
                   Témoins
                </mat-panel-title>
                <ng-template matExpansionPanelContent>
                    <div>
                        <div class="table-wrapper"> 
                            <table mat-table [dataSource]="dataSourceTemoins" matSort class="w-100">                                
                                
                                <ng-container matColumnDef="nom">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Temoin </th>
                                    <td mat-cell *matCellDef="let temoin">{{temoin.NomPrenomTemoin}} XOF</td>
                                </ng-container> 
                                
                                <ng-container matColumnDef="adresse">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Adresse </th>
                                    <td mat-cell *matCellDef="let temoin">{{temoin.AdresseTemoin}} XOF</td>
                                </ng-container> 
                               
                                <ng-container matColumnDef="telephone">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Téléphone </th>
                                    <td mat-cell *matCellDef="let temoin">{{temoin.TelTemoins}}</td>
                                </ng-container> 
                        
                            
                                <tr mat-header-row *matHeaderRowDef="displayedColumnsTemoins"></tr>
                                <tr mat-row *matRowDef="let temoin; columns: displayedColumnsTemoins;"></tr>
                            </table> 
                            <p *ngIf="dataSourceTemoins && dataSourceTemoins.data.length === 0" class="py-5 mb-0 text-center">Pas de données disponibles</p> 
                        </div>
                        <mat-paginator [pageSizeOptions]="[10, 20, 30, 40, 50]"></mat-paginator>
                    </div>
                  </ng-template>
                </mat-expansion-panel-header>
        </mat-expansion-panel>

        <mat-expansion-panel style="margin-top:10px">
            <mat-expansion-panel-header>
                <mat-panel-title>
                   Blessées
                </mat-panel-title>
                <ng-template matExpansionPanelContent>
                    <div>
                        <div class="table-wrapper"> 
                             <table mat-table [dataSource]="dataSourceBlesser" matSort class="w-100">                                
                                
                                <ng-container matColumnDef="nom">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Temoin </th>
                                    <td mat-cell *matCellDef="let blesser">{{blesser.NomPrenomBlesse}} XOF</td>
                                </ng-container> 
                                
                                <ng-container matColumnDef="adresse">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Adresse </th>
                                    <td mat-cell *matCellDef="let blesser">{{blesser.AdresseBlesse}} XOF</td>
                                </ng-container> 
                               
                                <ng-container matColumnDef="nature">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Nature de la blessure </th>
                                    <td mat-cell *matCellDef="let blesser">{{blesser.NatureBlessure}}</td>
                                </ng-container>                         
                            
                                <tr mat-header-row *matHeaderRowDef="displayedColumnsBlesser"></tr>
                                <tr mat-row *matRowDef="let blesser; columns: displayedColumnsBlesser;"></tr>
                            </table>  
                            <p *ngIf="dataSourceBlesser && dataSourceBlesser.data.length === 0" class="py-5 mb-0 text-center">Pas de données disponibles</p> 
                        </div>
                        <mat-paginator [pageSizeOptions]="[10, 20, 30, 40, 50]"></mat-paginator>
                    </div>
                  </ng-template>
               
                </mat-expansion-panel-header>
        </mat-expansion-panel>

         <mat-expansion-panel style="margin-top:10px">
            <mat-expansion-panel-header>
            <mat-panel-title>
               Autre Information du Sinistre
            </mat-panel-title>
            </mat-expansion-panel-header>
            <div fxLayout="row">
                <mat-list role="list" fxFlex="100" fxFlex.gt-sm="100">
                    <mat-list-item role="listitem">
                        <span class="label-text"><b>Numero Rapport d'agent ou PV de gendarmerie ACC7156 :</b></span>
                        <span class="text-value">{{sinistres.NumRapportPV }}</span> 
                        <mat-divider></mat-divider>
                    </mat-list-item>
                </mat-list>
            </div>

            <div class="flex-container" >
                
                <div class="flex-item-left br">
                    <mat-list role="list">
                        <mat-list-item role="listitem">
                            <span class="label-text"><b>Nature des dégats :</b></span> <br>
                            <span class="text-value">{{sinistres.degats_description}}</span> 
                            
                            <mat-divider></mat-divider>
                        </mat-list-item>
                        <mat-list-item role="listitem">
                            <span class="label-text"><b>Description du sinistre :</b></span>
                            <span class="text-value">{{sinistres.sinister_description}}</span> 
                            <mat-divider></mat-divider>
                        </mat-list-item>
                    </mat-list>
                </div>
                <div class="flex-item-right">
                    <mat-list role="list">
                        <mat-list-item role="listitem">
                            <span class="label-text"><b>Nature des degats des vehicules tiers :</b></span>
                            <span class="text-value">{{sinistres.NatureDegatSurVehicule}}</span> 
                            <mat-divider></mat-divider>
                        </mat-list-item>
                        <mat-list-item role="listitem">
                            <span class="label-text"><b>Circonstances détaillées :</b></span>
                            <span class="text-value">{{sinistres.CirconstanceDetails}}</span>  
                            <mat-divider></mat-divider>
                        </mat-list-item>
                    </mat-list>
                </div>
            </div>
        </mat-expansion-panel>
    
    </mat-accordion>
</div>

<ngx-spinner type="ball-clip-rotate-multiple" color="#e91e63" bdColor="rgba(51,51,51,0.8)">
    <p style="font-size: 20px; color: #e91e63; margin-top: 20px; font-weight: bold;">Loading...</p>
</ngx-spinner>
